import { render, staticRenderFns } from "./groupType.vue?vue&type=template&id=387294f5&scoped=true"
import script from "./groupType.vue?vue&type=script&lang=ts"
export * from "./groupType.vue?vue&type=script&lang=ts"
import style0 from "./groupType.vue?vue&type=style&index=0&id=387294f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387294f5",
  null
  
)

export default component.exports